import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import FormInput from "../../components/FormInput";
import { Link } from "react-router-dom";

export default function Profile() {
  return (
    <>
      <Row className='align-items-center mb-2'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Profile</h1>
        </Col>
        <Col sm='auto'>
          <div className='justify-content-between'>
            <Link to={"/"} className='btn btn-sm btn-primary my-1 text-white'>
              Update
            </Link>
          </div>
        </Col>
      </Row>
      <Card>
        <CardHeader>
          <h5 className='m-0'>Change Password</h5>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={8}>
              <Row>
                <Col md={6}>
                  <FormInput label='Old Password' name='oldPassword' />
                </Col>
                <Col md={6}></Col>
                <Col md={6}>
                  <FormInput label='New Password' name='newPassword' />
                </Col>
                <Col md={6}>
                  <FormInput label='Confirm New Password' name='confirmPassword' />
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
}
